import { render, staticRenderFns } from "./AvatarIcon.vue?vue&type=template&id=3c5d3286&scoped=true"
import script from "./AvatarIcon.vue?vue&type=script&lang=js"
export * from "./AvatarIcon.vue?vue&type=script&lang=js"
import style0 from "./AvatarIcon.vue?vue&type=style&index=0&id=3c5d3286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d3286",
  null
  
)

export default component.exports